const LoginMiddleware = (store) => (next) => (action) => {
  if (action.type === 'AUTH_STATE_CHANGED') {
    const { user } = action

    const isLoggedIn = user && user.emailVerified && user.email
    if (isLoggedIn) {
      // /v3/account is the login endpoint (POST) and returns the account uuid used as the
      // Firebase Storage folder for player/disc thumbs. It must be POST — a GET 405s and
      // leaves auth.uuid empty, which silently breaks all thumb loading.
      store.dispatch({
        type: 'GET_ACCOUNT_UUID',
        payload: {
          request: {
            method: 'post',
            url: `/v3/account`,
          },
        },
      })

      store.dispatch({
        type: 'LOAD_USER_DATA',
        payload: {
          request: {
            url: `/v4/sync/0`,
          },
        },
      })
    }
  }

  return next(action)
}

export default LoginMiddleware
